// Reels API helpers. Events are fire-and-forget but retried ONCE when the analytics session is not open yet
// (the pageview beacon may still be in flight) so an early interaction is not lost. Never creates a visit.
import { api, API_BASE } from "@/lib/api";
import { newOpId } from "@/lib/readerEvents";
import { whenQuiet } from "@/lib/netGate";

// Paged (12 per call) so the feed never loads every video at once. Returns { items, next_cursor }.
export const fetchReels = ({ cursor, v } = {}) => api.get("/public/reels", { params: { cursor: cursor || undefined, v: v || undefined } }).then((r) => r.data);
export const fetchReelsForArticle = (id, cursor) => api.get(`/public/reels/for-article/${id}`, { params: { cursor: cursor || undefined } }).then((r) => r.data);

// Short share link served by the backend: rich preview (title / poster / video) for WhatsApp, Facebook, X, Telegram…,
// then an instant redirect to THIS clip in the reels viewer for people.
export const reelShareUrl = (p, reel) => `${window.location.origin}/api/s/r/${reel.id}${p ? `?lang=${p.slice(1)}` : ""}`;
export const reelDownloadUrl = (id) => `${API_BASE}/public/reels/${id}/download`;

const post = (url, body) => fetch(url, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), keepalive: true, priority: "low" });
const quiet = () => new Promise((res) => whenQuiet(res));

export async function sendReelEvent(kind, { articleId, source, target, lang, opId }) {
    const body = { op_id: opId || newOpId(), kind, article_id: articleId || null, source: source || "reels", target: target || null, lang: lang || null };
    try {
        await quiet();   // the playing clip fills its buffer first; same op_id → counted once whenever it lands
        const r = await post(`${API_BASE}/public/reels/event`, body);
        const d = await r.json().catch(() => ({}));
        if (d?.skipped === "no_session") {
            await new Promise((res) => setTimeout(res, 2000));
            await post(`${API_BASE}/public/reels/event`, body);   // same op_id → still counted once
        }
    } catch { /* never block the visitor */ }
}

/** Atomic like toggle. Resolves {liked, likes}; throws on network/server failure so the UI can roll back. */
export async function toggleReelLike(articleId, on, source) {
    const r = await post(`${API_BASE}/public/reels/${articleId}/like`, { op_id: newOpId(), on, source: source || "reels" });
    if (!r.ok) throw new Error(`like_${r.status}`);
    return r.json();
}

/** Where the visitor came into the player from — locked once per page load. */
export function detectReelSource(search, embedded) {
    if (embedded) return "article";
    try { if (new URLSearchParams(search).get("v")) return "direct"; } catch { /* noop */ }
    return "reels";
}
